/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private readonly loading = new BehaviorSubject<boolean>(false);
  public readonly loadingSpinner = this.loading.asObservable();

  constructor() { }

  showSpinner() {
    this.loading.next(true);
  }

  hideSpinner(){
    this.loading.next(false);
  }
}
